export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15127.61a2ee21.jpg";